import { AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { IDriftEntryDto } from 'src/app/models/features/schema-drift/IDriftEntryDto';
import { HeaderService } from '../../../../services/_app/header/header.service';
import { SchemaDriftService } from '../../../../services/_app/schema-drift/schema-drift.service';
import { AuditProfileService } from '../../../../services/audit-profile/audit-profile.service';
import { BaseComponent } from '../../../base/base.component';
import { NgxChartsModule, Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-drift-trend-chart',
  templateUrl: './drift-trend-chart.component.html',
  styleUrls: ['./drift-trend-chart.component.css'],
})
export class DriftTrendChartComponent extends BaseComponent implements OnInit, AfterViewInit {
  // *********************
  // variables declaration
  // *********************

  // private
  // ********

  // public
  // ******
  @Input() driftData: any;
  @Input() isDark = false;

  public chartData: any[] = [];
  public view: [number, number] = [900, 360];
  public showLegend = true;
  public xAxisLabel = 'Date';
  public yAxisLabel = 'Schema Changes';
  public legendTitle = 'Change Type';

  constructor(private auditProfileService: AuditProfileService,
    private headerService: HeaderService,
    private schemaDriftService: SchemaDriftService,
    private router: Router) {
    super();
  }

  // ***************
  // lifecycle hooks
  // ***************

  override async ngOnInit() {
    await this.housekeeping();
  }

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('DriftTrendChartComponent - ngOnChanges', changes);
    if (changes['driftData']) {
      this.tryBuild();
    }
  }

  // *******
  // methods
  // *******

  // public
  // ******

  public get colorScheme(): Color {
    return {
      name: 'driftScheme',
      selectable: true,
      group: ScaleType.Ordinal,
      domain: this.isDark
        ? ['#22c55e', '#eab308', '#ef4444']  // bright colors for dark mode
        : ['#16a34a', '#f59e0b', '#dc2626']  // standard colors
    };
  }

  public getTotal(seriesGroup: any): number {
    return seriesGroup?.series?.reduce((acc: number, cur: any) => acc + cur.value, 0) || 0;
  }

  // private
  // *******

  private async housekeeping() {
    this.tryBuild();
  }

  private tryBuild(): void {
    const entries = this.driftData?.ParsedDrift;

    if (!entries || entries.length === 0) {
      this.chartData = [];

      return;
    }

    this.chartData = this.buildSeries(entries);
  }

  private buildSeries(entries: IDriftEntryDto[]): any[] {
    const map = new Map<string, { Added: number; Archived: number; Removed: number }>();

    for (const e of entries) {
      if (!map.has(e.date)) map.set(e.date, { Added: 0, Archived: 0, Removed: 0 });
      const d = map.get(e.date)!;
      if (e.action === 'Added') d.Added++;
      else if (e.action === 'Archived') d.Archived++;
      else if (e.action === 'Removed') d.Removed++;
    }

    const added = { name: 'Added', series: [] as any[] };
    const archived = { name: 'Archived', series: [] as any[] };
    const removed = { name: 'Removed', series: [] as any[] };

    Array.from(map.entries())
      .sort((a, b) => a[0].localeCompare(b[0]))
      .forEach(([date, count]) => {
        added.series.push({ name: date, value: count.Added });
        archived.series.push({ name: date, value: count.Archived });
        removed.series.push({ name: date, value: count.Removed });
      });

    return [added, archived, removed];
  }
}
